import React from 'react'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/Navbar'
import CaseStudyTab from './../../components/CaseStudyTab';
import IndustriesImageContainer from '../../components/IndustriesImageContainer';
import Footer from '../../components/Footer';
import ashoka from "../../assets/images/contents/case-study-ashoka.png"
import document_security from "../../assets/images/contents/case-study-document-security.png"
import { StyledLink } from '../../components/StyledComponents';
import filter_color from "../../assets/images/design/colorFilter.svg"
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';

const CaseStudy = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  return (
    <div className='case-study bg-primary'>
      <div className='color-filter-left' style={{ top: "35%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid case-study-header pb-100'>
      </div>
      <div className='container case-study-margin'>
        <div className='col-sm-12'>
          {language === "en"
            ?
            <p className='font-weight-bold text-center font-96 case-study-header-title'>CASE STUDIES</p>
            :
            <p className='font-weight-bold text-center font-96 case-study-header-title pr-20'>NGHIÊN CỨU</p>
          }
        </div>
        <div className='col-sm-12 flex justify-center pt-lg-120 pt-50'>
          <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.case-studies')} />
        </div>
      </div>
      <div className='mt-lg-200 mt-50'>
        <CaseStudyTab allCaseStudiesActive={true} />
      </div>
      <div className='case-study-content container'>
        <div className='row'>
          <div className="col-lg-4">

            <div className='case-study-card'>
              <StyledLink href="/case-study/ashoka">
                <div className='case-study-card_image'>
                  <img src={ashoka} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip'>
                {t('case-study.education')}
              </div>
              <StyledLink href="/case-study/ashoka">
                <p className='text-white font-weight-semi-bold font-20'>{t('case-study.card-title-1')}</p>
              </StyledLink>
              <p className='text-gray'>{t('case-study.card-content-1')} <span className='font-weight-bold'>{t('case-study.download-case-study-for-free')}</span></p>
            </div>

          </div>

          <div className="col-lg-4">

            <div className='case-study-card'>
              <StyledLink href="/case-study/karibia">
                <div className='case-study-card_image'>
                  <img src={document_security} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip'>
                {t('case-study.document-security')}
              </div>
              <StyledLink href="/case-study/karibia">
                <p className='text-white font-weight-semi-bold font-20'>{t('case-study.card-title-2')}</p>
              </StyledLink>
              <p className='text-gray'>{t('case-study.card-content-2')}  <span className='font-weight-bold'>{t('case-study.download-case-study-for-free')}</span></p>
            </div>

          </div>

        </div>


      </div>
      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
    </div>
  )
}

export default CaseStudy